import React from 'react';
import { Button } from '../Button';
import { spacing } from '../../theme/spacing';
import { typography } from '../../theme/typography';
import { colors } from '../../theme/colors';

export const SuccessView: React.FC = () => {
    const handleClose = () => {
        // Refresh page or navigate to homepage
        window.location.href = '/';
    };

    return (
        <>
            <style>{`
                @keyframes fadeInSuccess {
                    from {
                        opacity: 0;
                    }
                    to {
                        opacity: 1;
                    }
                }
            `}</style>
            <div style={{
                textAlign: 'center',
                padding: `${spacing[48]} 0`,
                animation: 'fadeInSuccess 200ms ease-out',
            }}>
                <h2 style={{
                    fontFamily: typography.fontFamily,
                    fontSize: '28px',
                    fontWeight: typography.weights.bold,
                    color: colors.primary.navy,
                    marginBottom: spacing[16],
                    marginTop: 0,
                }}>
                    Kiitos! Varauspyyntö vastaanotettu.
                </h2>
                <p style={{
                    fontFamily: typography.fontFamily,
                    fontSize: typography.sizes.body.fontSize,
                    color: colors.text.primary,
                    lineHeight: 1.6,
                    marginBottom: spacing[8],
                }}>
                    Olemme vastaanottaneet varauspyyntösi.
                </p>
                <p style={{
                    fontFamily: typography.fontFamily,
                    fontSize: typography.sizes.body.fontSize,
                    color: colors.text.primary,
                    lineHeight: 1.6,
                    marginBottom: spacing[8],
                }}>
                    Käymme sen läpi ja vahvistamme tarkan huoltopäivän 1–2 arkipäivässä.
                </p>
                <p style={{
                    fontFamily: typography.fontFamily,
                    fontSize: typography.sizes.body.fontSize,
                    color: colors.text.primary,
                    lineHeight: 1.6,
                    marginBottom: spacing[32],
                }}>
                    Saat vahvistuksen sähköpostiisi.
                </p>

                <div style={{
                    backgroundColor: colors.background.offWhite,
                    padding: spacing[16],
                    borderRadius: '8px',
                    marginBottom: spacing[32],
                    fontSize: typography.sizes.small.fontSize,
                    color: colors.text.muted,
                    lineHeight: 1.5,
                }}>
                    Jos haluat perua tai muuttaa varausta, ota yhteyttä:<br />
                    <strong>info@ramstedt.fi</strong>
                </div>

                <Button
                    variant="primary"
                    onClick={handleClose}
                >
                    Sulje
                </Button>
            </div>
        </>
    );
};
